import { IconButton, Table3 } from '@economic/taco';
import { t } from '@lingui/macro';
import React from 'react';
import date from '~/app/shared/util/utilities/date';
import number from '~/app/shared/util/utilities/number';
import { ExternalBillingItemDto } from './types';

interface Props {
    data: ExternalBillingItemDto[];
    onEdit: (webhook: ExternalBillingItemDto) => void;
}

export default function ExternalBillingItemsTable({ data, onEdit }: Props) {
    const rowActions = [
        (externalBillingItemDto: ExternalBillingItemDto) => (
            <IconButton aria-label={t`Edit`} icon="edit" onClick={() => onEdit(externalBillingItemDto)} />
        ),
    ];

    return (
        <Table3<ExternalBillingItemDto> data={data} id="external-billing-items" enableColumnResizing rowActions={rowActions}>
            <Table3.Column<ExternalBillingItemDto> id="id" header={t`Id`} renderer={value => Number(value)} />
            <Table3.Column<ExternalBillingItemDto>
                id="licenseModuleId"
                defaultWidth={150}
                header={t`License module id`}
                renderer={value => Number(value)}
            />
            <Table3.Column<ExternalBillingItemDto>
                id="registeredDate"
                header={t`Registered Date`}
                defaultWidth={150}
                renderer={value => {
                    const renderValue = date.format(date.parseFromISOString(value));
                    if (renderValue === undefined) {
                        return '';
                    }
                    return renderValue;
                }}
            />
            <Table3.Column<ExternalBillingItemDto>
                id="deregisteredDate"
                header={t`Deregistered Date`}
                defaultWidth={150}
                renderer={value => {
                    const renderValue = date.format(date.parseFromISOString(value));
                    if (renderValue === undefined) {
                        return '';
                    }
                    return renderValue;
                }}
            />
            <Table3.Column<ExternalBillingItemDto> id="billingText" header={t`Billing text`} />
            <Table3.Column<ExternalBillingItemDto>
                id="discountPercentage"
                header={t`Discount`}
                align="right"
                renderer={value => (value ? number.format(value) + ' %' : '')}
            />
            <Table3.Column<ExternalBillingItemDto>
                id="discountExpiry"
                header={t`Discount expiry`}
                renderer={value => {
                    const renderValue = date.format(date.parseFromISOString(value));
                    if (renderValue === undefined) {
                        return '';
                    }
                    return renderValue;
                }}
            />
        </Table3>
    );
}
